export const CRMTask = [
    {
        "id": 212,
        "name": "iBiz FAQs from MWS Meghavi Spa",
        "project": "iBizAccounts - Perennial Developers",
        "status": "Awaiting Feedback",
        "start_date": "27/11/2024",
        "due_date": "27/11/2024",
        "assigned_to": ["John Doe", "Jane Smith"],
        "tags": ["Documentation", "FAQs"],
        "priority": "Medium"
    },
    {
        "id": 543,
        "name": "All the employees are not showing in the Bulk update report & Bulk attendance is not updating",
        "project": "ION EXCHANGE (INDIA) LIMITED",
        "status": "Not Started",
        "start_date": "20/02/2025",
        "due_date": "26/02/2025",
        "assigned_to": ["Robert White", "Sophia Lee"],
        "tags": ["HR", "Attendance", "Bug"],
        "priority": "Medium"
    },
    {
        "id": 614,
        "name": "Registrations are not displaying in the portal",
        "project": "One Rise Vacations LLP",
        "status": "Not Started",
        "start_date": "13/03/2025",
        "due_date": "14/03/2025",
        "assigned_to": ["David Miller", "Emily Davis"],
        "tags": ["User Management", "Bug"],
        "priority": "Medium"
    },
    {
        "id": 622,
        "name": "Break, Late, Leaves Alerts are not getting",
        "project": "Global Information Technology, Inc.",
        "status": "Not Started",
        "start_date": "03/03/2025",
        "due_date": "14/03/2025",
        "assigned_to": ["James Martin", "Olivia Harris"],
        "tags": ["Notifications", "HR"],
        "priority": "Urgent"
    }
]
